import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Stock from "@/pages/Stock";
import VHU from "@/pages/VHU";
import Clients from "@/pages/Clients";
import Repairs from "@/pages/Repairs";
import Devis from "@/pages/Devis";
import Encaissement from "@/pages/Encaissement";
import Orders from "@/pages/Orders";
import Catalog from "@/pages/Catalog";
import Users from "@/pages/Users";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/stock" element={<Stock />} />
              <Route path="/vhu" element={<VHU />} />
              <Route path="/reparations" element={<Repairs />} />
              <Route path="/clients" element={<ProtectedRoute full><Clients /></ProtectedRoute>} />
              <Route path="/commandes" element={<ProtectedRoute full><Orders /></ProtectedRoute>} />
              <Route path="/catalogue" element={<ProtectedRoute full><Catalog /></ProtectedRoute>} />
              <Route path="/devis" element={<ProtectedRoute full><Devis /></ProtectedRoute>} />
              <Route path="/encaissement" element={<ProtectedRoute full><Encaissement /></ProtectedRoute>} />
              <Route path="/utilisateurs" element={<ProtectedRoute full><Users /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="bottom-right" richColors theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
